<div>

  @if (dadosTaxasOperadoras) {
    <table class="table table-hover border-bottom">
      <caption>Tabela com lista de taxas das operadoras do pedido</caption>
      <thead>
        <tr>
          <th scope="col" class="border-top-0">CÓDIGO</th>
          <th scope="col" class="border-top-0">DESCRIÇÃO</th>
          <th scope="col" class="border-top-0">QTDE.</th>
          <th scope="col" class="border-top-0">UNIT.</th>
          <th scope="col" class="border-top-0">SUBTOTAL</th>
        </tr>
      </thead>
      <tbody>
        <!-- LINHA 1 -->
        @for (taxa of dadosTaxasOperadoras | paginate: { id: 'paginacaoTaxas',
          itemsPerPage: taxasPorPagina,
          currentPage: paginaTaxas,
          totalItems: $safeNavigationMigration(dadosTaxasOperadoras?.length) }; track taxa) {
          <tr>
            <td>{{taxa.codigoVenda}}</td>
            <td>{{taxa.descricao}}</td>
            <td>{{taxa.quantidade}}</td>
            <td>{{taxa.valorUnitario | currency: 'BRL'}}</td>
            <td>{{taxa.subtotal | currency: 'BRL'}}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (dadosTaxasOperadoras) {
    <div class="footer-card">
      <div>
        <app-select
          [value]="taxasPorPagina"
          (valueChanges)="onTaxasPorPaginaChange($event)"
          name="taxasPorPaginaName"
                  [options]="[
                  {name : 'Exibir 3 por página' , value : '3'} ,
                  {name : 'Exibir 5 por página' , value : '5'} ,
                  {name : 'Exibir 7 por página' , value : '7'} ,
                  {name : 'Exibir 9 por página' , value : '9'}

                  ]"
          optionValue="value"
          optionText="name">
        </app-select>
      </div>
      <!-- Paginação CENTRAL -->
      <div>
        <pagination-controls class="my-pagination" id="paginacaoTaxas" directionLink="true" (pageChange)="paginaTaxas = $event" responsive="true" previousLabel="Anterior" nextLabel="Próxima"></pagination-controls>
      </div>
      <div>
        <p><span class="itens-pagina">{{dadosTaxasOperadoras.length}}</span> Registros foram encontrados</p>
      </div>
    </div>
  }

  @if (dadosTaxasOperadoras === null) {
    <div>
      <div class="text-center">
        <output class="spinner-border c-primary">
          <span class="visually-hidden">Consultando dados das Taxas de Operadoras ...</span>
        </output>
      </div>
      <p class="legenda-spinner">Consultando dados das Taxas de Operadoras ...</p>
    </div>
  }

  @if (dadosTaxasOperadoras === false) {
    <div class="text-center">
      <img src="/assets/img/erro.png" alt="representando erro na consulta de taxas dos pedidos" width="200px">
      <p class="legenda-erro">Ocorreu um erro na consulta das taxas. Verifique se o número do pedido está correto.</p>
    </div>
  }

  @if (dadosTaxasOperadoras === 404) {
    <div class="text-center">
      <img src="/assets/img/erro.png" alt="representando erro na consulta de taxas dos pedidos" width="200px">
      <p class="legenda-erro">Não existem taxas para o pedido selecionado.</p>
    </div>
  }
</div>
